module.exports = {"id":"212474","name":"Tiago Silva","rating":"73","photo":"./data/images/photos/3/212474.png","club":{"name":"F. Santa Maria","logo":"./data/images/clubs/F.SantaMaria.png"},"positions":["MOC","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TiagoSilva0.json
// module id = 4126
// module chunks = 0